import { useTranslation } from 'react-i18next';
import { useNewCommunicationActions } from './context/useNewCommunicationActions';
import { useNewCommunicationValues } from './context/useNewCommunicationValues';
import { RecipientsLists } from './RecipientsLists';
import { RecipientsRecap } from './RecipientsRecap';
import { RefineRuleSection } from './RefineRuleSection';

export const RecipientsStepContainer = () => {
  const { t } = useTranslation('comuni');
  const { baseLists, isListsLoading, selectedIds } = useNewCommunicationValues();
  const { toggleList } = useNewCommunicationActions();

  if (isListsLoading) return <div>Loading...</div>;

  return (
    <div className='grid grid-cols-1 gap-4 rounded-2xl border p-6'>
      <div className='w-full'>
        <h3 className='text-[26px] font-extrabold tracking-tight text-primary-900'>{t('composer.title')}</h3>
        <p className='mt-1.5 text-[15px] text-tertiary-600'>{t('composer.subtitle')}</p>
      </div>
      <RecipientsLists list={baseLists} selectedIds={selectedIds} onToggleList={toggleList} />
      <RefineRuleSection />
      <RecipientsRecap />
    </div>
  );
};
